import {
  MdDashboard,
  MdSubscriptions,
  MdInventory2,
  MdPeople,
  MdManageAccounts,
  MdAccountBalance,
  MdNotifications,
  MdAssessment,
  MdPayment,
  MdSettings,
  MdPerson,
} from 'react-icons/md';

export const ownerNavItems = [
  { path: '/owner/dashboard', label: 'Dashboard', icon: MdDashboard, end: true },
  { path: '/owner/users', label: 'Gym Admins', icon: MdPeople },
  { path: '/owner/packages', label: 'Subscription Packages', icon: MdInventory2 },
  { path: '/owner/subscriptions', label: 'Gym Subscriptions', icon: MdSubscriptions },
  { path: '/owner/user-management', label: 'User Management', icon: MdManageAccounts },
  { path: '/owner/finance', label: 'Financial Management', icon: MdAccountBalance },
  { path: '/owner/notifications', label: 'Notifications', icon: MdNotifications },
  { path: '/owner/reports', label: 'Reports', icon: MdAssessment },
  { path: '/owner/payment-gateway', label: 'Payment Gateway', icon: MdPayment },
  { path: '/owner/settings', label: 'Settings', icon: MdSettings },
  { path: '/owner/profile', label: 'Profile', icon: MdPerson },
];
